import { createContext } from 'react';

export type QuestionEditorContextValue = {
  questionId: string;
};

export const QuestionEditorContext = createContext<QuestionEditorContextValue | null>(null);
